import React from 'react';
import { isAllowEdit } from 'features/supplier/utils';

const EditButton = ({ onEditClick }) => {
	return (
		isAllowEdit() && (
			<span className="ml-12">
				<button className="blue border-0 medium-14 bg-transparent" onClick={() => onEditClick()}>
					Edit
				</button>
			</span>
		)
	);
};

export default EditButton;
